import { z } from 'zod'

import { ConfirmationRequestStatus } from '../constants/confirmationRequest'
import { PaymentAmountType } from '../constants/pricing'
import { dbEntitySchema } from './system'
import { feeSchema } from './pricing'
import { personDisplaySchema } from './personDisplay'

export const confirmationRequestSchema = dbEntitySchema.extend({
  admissionGroup: z.string(),
  expires: z.date().optional().nullable(),
  inventory: z.string(),
  customer: z.string().optional().nullable(),
  booking: z.string().optional().nullable(),
  venue: z.string(),
  date: z.date(),
  guests: z.number(),
  paymentAmountType: z.nativeEnum(PaymentAmountType),
  paymentAmount: z.number(),
  totalAmount: z.number(),
  createdById: z.string().optional().nullable(),
  createdBy: personDisplaySchema.optional().nullable(),
  quantity: z.number().optional().nullable(),
  name: z.string().optional().nullable(),
  message: z.string().optional().nullable(),
  clientName: z.string().optional().nullable(),
  clientEmail: z.string().optional().nullable(),
  clientPhone: z.string().optional().nullable(),
  link: z.string().optional().nullable(),
  status: z.nativeEnum(ConfirmationRequestStatus),
  tax: z.number().optional().nullable(),
  tip: z.number().optional().nullable(),
  fees: z.array(feeSchema).optional().nullable(),
  userPaysProcessing: z.boolean().optional().nullable(),
  managementUserNotifyOnComplete: z.string().optional().nullable(),
})

export const createConfirmationRequestInputSchema = z.object({
  admissionGroupId: z.string(),
  name: z.string().optional().nullable(),
  message: z.string().optional().nullable(),
  paymentAmountType: z.nativeEnum(PaymentAmountType),
  paymentAmount: z.number().min(0),
  quantity: z.number().min(0).optional().nullable(),
  tax: z.number().optional().nullable(),
  tip: z.number().optional().nullable(),
  fees: z.array(feeSchema).optional().nullable(),
  userPaysProcessing: z.boolean().optional().nullable(),
  managementUserNotifyOnComplete: z.string().optional().nullable(),
})

export const listConfirmationRequestQuerySchema = z.object({
  admissionGroupId: z.string().optional().nullable(),
  venueId: z.string().optional().nullable(),
  date: z.coerce.date().optional().nullable(),
  status: z.nativeEnum(ConfirmationRequestStatus).optional().nullable(),
  sort: z.string().optional().nullable(),
  after: z.string().optional().nullable(),
})

export const confirmationRequestInviteEmailArgsSchema = z.object({
  confirmationRequestId: z.string(),
  email: z.string(),
})

export const confirmationRequestInviteTextArgsSchema = z.object({
  confirmationRequestId: z.string(),
  phone: z.string(),
})
